<template>
    <v-container>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Актуальные задачи</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form
                            @submit.prevent="search.filter.page = 1; searchCompanies()"
                            autocomplete="off"
                            class="col-md-6 pa-0"
                        >
                            <v-select
                                v-model="search.filter.manager_id"
                                @change="searchTasks"
                                :error-messages="search.errors.manager_id"
                                :items="manager.search.data"
                                :cache-items="true"
                                item-text="name"
                                item-value="id"
                                label="Администратор"
                                clearable
                            ></v-select>
                        </v-form>
                        <br>
                        <v-data-table
                            :headers="search.headers"
                            :items="search.data"
                            disable-sort
                            disable-pagination
                            hide-default-footer
                            :loading="search.loading"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left text-no-wrap">{{ item.manager.name }}</td>
                                    <td class="text-left text-no-wrap">
                                        <router-link
                                            :to="{name: 'CompanyView', params: {id: item.company_id}}"
                                            class="mt-3 mr-2"
                                        >
                                            {{ item.company.name }}
                                        </router-link>
                                    </td>
                                    <td class="text-left">{{ item.message }}</td>
                                    <td class="text-left text-no-wrap">{{ item.schedule }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "TaskController",
    props: {
        schedule: Boolean,
    },
    data () {
        return {
            manager: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            search: {
                data: [],
                errors: {
                    manager_id: [],
                },
                filter: {
                    manager_id: '',
                },
                headers: [
                    {
                        text: 'Администратор',
                        value: 'manager.name',
                    },
                    {
                        text: 'Компания',
                        value: 'company.name',
                    },
                    {
                        text: 'Задача',
                        value: 'message',
                    },
                    {
                        text: 'Срок',
                        value: 'schedule',
                    },
                ],
                loading: true,
                total: 0,
            },
        }
    },
    computed: {
        user: function () {
            return this.$store.getters.user
        },
    },
    created () {
        this.search.filter.manager_id = parseInt(this.user.id)
        this.searchManagers()
        this.searchTasks()
    },
    watch: {
        '$route' () {
            this.searchTasks()
        },
    },
    methods: {
        searchTasks () {
            this.search.loading = true

            this.$axios.post('/manager/company/task/search', {...this.search.filter, schedule: this.schedule})
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        searchManagers () {
            this.manager.search.loading = true

            this.$axios.post('/manager/user/search')
                .then(res => {
                    if (res.data.success) {
                        this.manager.search.data = res.data.data.filter(m => {return m.manager})
                    }

                    this.manager.search.loading = false
                })
                .catch(() => {
                    this.manager.search.loading = false
                })
        },
    },
}
</script>

<style>
a {
    text-decoration: none;
}
</style>
